import { REGISTER_USER_URL, ROOT_URL } from '../constants/endpoints';

import axios from 'axios';
export const register = async (
    name: string,
    email: string,
    password: string
): Promise<boolean> => {
    try {
        const { data } = await axios.post(
            `${ROOT_URL}/${REGISTER_USER_URL}`,
            { name, email, password },
            {
                withCredentials: true,
            }
        );

        if (data) {
            return true;
        }
        throw new Error();
    } catch (error) {
        throw new Error(error);
    }
};
